import React, { FC } from 'react';
import Modal from '@common/modal';
import { PACCApplyStatusRs, PSTApplyStatusRs } from '@domain/rs/phs/apply/PhsApplyStatusRs';

import classnames from 'classnames/bind';
import styles from './apply.module.scss';
const cx = classnames.bind(styles);

interface IApplyModalProps {
  type: 'PACC' | 'PST';
  visible: boolean;
  onClose: () => void;
  onFirstApply: () => void;
  onContinue: () => void;
  isDisabledContinueBtn?: boolean;
  vo?: PACCApplyStatusRs | PSTApplyStatusRs;
}

const ApplyModal: FC<IApplyModalProps> = ({
  type,
  vo,
  visible,
  onClose,
  onFirstApply,
  onContinue,
  isDisabledContinueBtn = false,
}) => {
  if (!vo) return null;

  const { chanceCount } = vo;
  const isDisabledFirstApply = chanceCount < 1;
  const titleText = type === 'PACC' ? '개발자 역량검사 응시하기' : '개발 구현 능력 검사 응시하기';

  return (
    <Modal visible={visible} dimmed={true}>
      <div className={cx('layer')}>
        <strong className={cx('title')}>{titleText}</strong>

        <div className={cx('btnArea')}>
          <button className={cx('btn', 'reTry')} type="button" disabled={isDisabledFirstApply} onClick={onFirstApply}>
            <em className={cx('btnTitle')}>처음부터 재응시하기</em>
            <p className={cx('btnDesc')}>
              응시 중이던 응시 기회 1회는
              <br />
              사라지게 됩니다.
            </p>
          </button>
          <button className={cx('btn', 'continue')} type="button" disabled={isDisabledContinueBtn} onClick={onContinue}>
            <em className={cx('btnTitle')}>이어서 응시하기</em>
            <p className={cx('btnDesc')}>
              응시 중단된 단계부터
              <br />
              시작합니다.
            </p>
          </button>
        </div>

        <a className={cx('btnClose')} onClick={onClose} role="button">
          <span className={cx('hidden')}>close</span>
        </a>
      </div>
    </Modal>
  );
};

export default ApplyModal;
